import React from "react";
import { Line } from "react-chartjs-2";
import PropTypes from "prop-types";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function LineChart({ values, index }) {
  const keys = Object.keys(values);
  const temp = values[keys[index]];
  const t = temp && temp.map((obj) => obj.temperature);

  const data = {
    labels: temp ? temp.map((obj) => obj.time) : "",
    datasets: [
      {
        label: "Today Temperature",
        data: t,
        backgroundColor: "rgba(255, 99, 132, 0.5)",
        borderColor: "rgb(255, 99, 132)",
      },
    ],
  };

  let options = {
    maintainAspectRation: false,
  };
  return (
    <div className="graph">
      <Line data={data} options={options} />
    </div>
  );
}
LineChart.defaultProps = {
  values: {},
  index: 0,
};

LineChart.propTypes = {
  values: PropTypes.object,
  index: PropTypes.number,
};
export default React.memo(LineChart);
